import { FunctionComponent } from 'react';
import { RouteComponentProps } from 'react-router';
import {
  CommunitiesV2Page,
  useIsCommunitiesV2Enabled,
} from '@client/new/features/communities-v2';
import { CommunityInitPage } from './communityInitPage';

type Props = { component: FunctionComponent } & RouteComponentProps<
  { influencerId?: string },
  unknown
>;

export const CommunityRouteSwitch = (props: Props) => {
  const { isLoading, isEnabled } = useIsCommunitiesV2Enabled(
    props.params?.influencerId,
  );
  const forceOld = props.location.query?.old !== undefined;

  if (isLoading) return null;

  if (isEnabled && !forceOld) {
    return <CommunitiesV2Page />;
  }

  return <CommunityInitPage {...props} />;
};
